import { put, takeEvery } from 'redux-saga/effects';
import uniqid from 'uniqid';
import {
  CREATE_SUPPORT_TICKET_REQUEST,
  CREATE_SUPPORT_TICKET_SUCCESS,
  CREATE_SUPPORT_TICKET_FAILURE,
  ADD_TOAST,
} from '../constants/action-types';
import sagaFetch from './SagaFetch';
import { hideModal } from '../actions';
import translations from '../lang';
import { fetchOpenTicketApi } from '../services/meApi';

function* fetchCreateSupportTicket(action) {
  const { data } = action;
  const { response, error } = yield sagaFetch(fetchOpenTicketApi, data);

  if (response) {
    return yield put({ type: CREATE_SUPPORT_TICKET_SUCCESS, response });
  }
  const id = uniqid();
  yield put({
    type: ADD_TOAST,
    id,
    toastProps: {
      status: 'error',
      message:
        error.message ||
        translations['en-US'].TOASTS.CREATE_SUPPORT_TICKET_ERROR,
    },
  });
  return yield put({ type: CREATE_SUPPORT_TICKET_FAILURE, error });
}

function* handleCreateSupportTicketSuccess(action) {
  const id = uniqid();
  yield put(hideModal());
  yield put({
    type: ADD_TOAST,
    id,
    toastProps: {
      status: 'success',
      message: translations['en-US'].TOASTS.CREATE_SUPPORT_TICKET,
    },
  });
}

export function* supportActionWatcher() {
  yield takeEvery(CREATE_SUPPORT_TICKET_REQUEST, fetchCreateSupportTicket);
  yield takeEvery(
    CREATE_SUPPORT_TICKET_SUCCESS,
    handleCreateSupportTicketSuccess
  );
}
